import { Helmet } from 'react-helmet-async';
import { Header } from '@/pages/public/landing/components/Header';
import { Footer } from '@/pages/public/landing/components/Footer';
import { ApresentacaoContent } from './ApresentacaoContent';

const ApresentacaoPage = () => {
	return (
		<>
			<Helmet>
				<title>Plumaa · Sua NR-1, sem trabalho extra para o RH</title>
				<meta
					name="description"
					content="NR-1 com laudo médico, painel mensal e devolutiva editorial. Primeiro mês grátis."
				/>
			</Helmet>
			<Header />
			<div
				className="apresentacao-deck text-base leading-relaxed text-[#1A1A1A] antialiased selection:bg-[#E06A30] selection:text-white"
				style={{
					backgroundColor: '#F7F4EE',
					backgroundImage:
						'radial-gradient(ellipse 900px 600px at 92% 3%, #FFEAE0 0%, transparent 60%), radial-gradient(ellipse 500px 500px at 5% 95%, rgba(250,128,70,0.05) 0%, transparent 70%)',
					backgroundAttachment: 'fixed',
				}}
			>
				<ApresentacaoContent />
			</div>
			<Footer />
		</>
	);
};

export { ApresentacaoPage };
